/* eslint no-reserved-keys: 0*/
export const quiet = 'mapbox://styles/citiesense/ckc6fzel218uv1jrj6qsnsbw2';
export const dark = 'mapbox://styles/citiesense/ckc6hk3cw1aan1ip649iv8s2f';
export const dark3D = 'mapbox://styles/citiesense/ck6h4nvgi099m1jqmkkc1x58q';
export const quiet3D = 'mapbox://styles/citiesense/ck6h4amgv08u31io8e4xxxgmx';
export const satellite = 'mapbox://styles/citiesense/cjlye22a45gxu2rpqwj31r3jh';
export const blueprint = 'mapbox://styles/citiesense/ck37qzcwr464d1cn6tc3yhyww';
export const slate = 'mapbox://styles/citiesense/ckc6hyxch1avc1imscuo0hrcj';
export const traditional =
  'mapbox://styles/citiesense/ck6a5fx7h033x1jszdle8i2uw';

export default {
  quiet,
  dark,
  'Dark 3D': dark3D,
  'Quiet 3D': quiet3D,
  satellite,
  blueprint,
  slate,
  traditional,
};
